export default __webpack_public_path__ + "static/media/img.ca3d8f72.svg";